module.exports = __webpack_public_path__ + "media/assets/site_images/photos_gallery/photo3-680eeda4eec1814fe4e7be4534b65fea.jpg";